<template>
  <div>
    <div class="orderbox">
      <div class="up">
        <div>订单编号：{{orderData && orderData.orderNo}}</div>
        <div class="info">
          <div class="infotitle">商品信息：</div>
          <div class="goods">{{orderData && orderData.goodsDesc}}</div>
        </div>
        <div>
          付款金额：
          <span class="num">{{orderData && orderData.amount}}</span>
        </div>
        <div>付款方式：微信支付</div>
        <div>订单完成时间：{{orderData && orderData.payTime}}</div>
      </div>
      <div class="tip">如需确认是否授权成功，请您进入账户中心查看个人权限</div>
      <div class="btn">
        <el-button
          style="background: #fad680; color: #8a6a1b; border-color: #fad680;"
          @click="openInvoice"
        >开具发票</el-button>
      </div>
      <div class="contact">客服电话：010-65185898 | +86 15210925572</div>
    </div>
  </div>
</template>

<script>
import { orderDetail } from "@/api/product";
export default {
  props: ["orderNo"],
  data() {
    return {
      orderData: {}
    };
  },
  components: {},
  created() {
    this.getOrderDetail();
  },
  methods: {
    async getOrderDetail() {
      let { data } = await orderDetail(this.orderNo);
      if (data.resultMessage == "处理成功") {
        this.orderData = data.resultBody;
      } else {
        this.$message.error(data.resultMessage);
        return;
      }
    },
    handleClosed() {
      this.$emit("closeOrder", "");
    },
    openInvoice() {
      this.dialogVisible = false;
      this.$emit("showDialog", 5);
    }
  }
};
</script>

<style lang="scss" scoped>
.orderbox {
  text-align: center;
  .up {
    background: #f8f9fb;
    margin: 0 20%;
    text-align: left;
    padding: 30px 10%;
    line-height: 24px;
    .num {
      color: #fc5d5d;
    }
    .info {
      display: flex;
      .infotitle {
        width: 70px;
      }
      .goods {
        flex: 1;
      }
    }
  }
  .tip {
    color: #999999;
    font-size: 12px;
    margin: 20px;
  }
  .btn {
    .el-button {
      width: 130px;
      height: 26px;
      line-height: 0;
      font-size: 12px;
    }
  }
  .contact {
    margin-top: 30px;
    font-size: 12px;
  }
}
</style>